module.exports = __webpack_public_path__ + "static/media/compilation.5b36c4d0.png";